import React, { useState } from "react";
import Button from "react-bootstrap/Button";

import { Link, useNavigate } from "react-router-dom";

import "react-phone-input-2/lib/bootstrap.css";

import "react-phone-input-2/lib/style.css";
import heliimg from "../../../assets/images/heli.png";
import logowhite from "../../../assets/images/logowhite.svg";
import arrowdrop from "../../../assets/images/arrow-drop.svg";
import uplodimg from "../../../assets/images/upload.png";
import myprofile from "../../../assets/images/avatar.svg";
import ChooseCatpopup from "../ChooseCatpopup";
import { useFormik } from "formik";
import * as Yup from "yup";
import { utilService, userService } from "services";
import LoaderIndicator from "components/LoaderIndicator";
import parse from 'html-react-parser';
import Images from "assets/images";
import useCurrentUser from "hooks/useCurrentUser";


const Step1 = () => {
  const [modalShow, setModalShow] = useState(false);
  const [error, setError] = useState(null);
  const [previews, setPreviews] = useState({});
  const [fileNames, setFileNames] = useState({});
  const [isUploading, setIsUploading] = useState({});
  const [isInValidFile, setIsInValidFile] = useState(false);
  const navigate = useNavigate();
  const { setUser: setCurrentUser } = useCurrentUser();
  const LIVE_SITE_URL = process.env.REACT_APP_LIVE_SITE_URL;

  const formik = useFormik({
    initialValues: {
      step: "1",
      avatar: "",
      uasManufacturer: "",
      uasModel: "",
      faaRegistrationNumber: "",
      faaRegistration: "",
      insuranceProof: "",
      pilotLicense: "",
      drivingLicense: "",
      specialisedId: {},
      // bio: "",
      // contractAgreement: "",
      // signature: ""
    },
    validationSchema: Yup.object().shape({
      avatar: Yup.string().optional(),
      uasManufacturer: Yup.string().required("Please enter UAS manufacturer"),
      uasModel: Yup.string().required("Please enter UAS model"),
      faaRegistrationNumber: Yup.string().required("Please enter FAA Registration"),
      faaRegistration: Yup.string().required("Please upload FAA Registration"),
      insuranceProof: Yup.string().required("Please upload insurance proof"),
      pilotLicense: Yup.string().required("Please upload pilot license"),
      drivingLicense: Yup.string().required("Please upload Driver's  license"),
    }),
    onSubmit: async (values) => {
      const payload = {
        ...values,
        specialisedId: Object.keys(values.specialisedId)
      }
      if (payload.specialisedId.length === 0) {
        setError('Please select category')
        return;
      }
      setError(null);
      try {
        const response = await userService.buildPilotProfile(payload);
        setCurrentUser(response?.data?.data);

        localStorage.setItem('userData', JSON.stringify(response?.data?.data));
        navigate('/profileStep2');
      } catch (err) {
        console.error(err?.response?.data?.message);
        setError(err?.response?.data?.message);
      }
    },
  });

  const handleSpeclialisedList = (item) => {
    const updatedValues = formik.values.specialisedId;
    if (updatedValues[item?._id]) {
      delete updatedValues[item?._id]
    } else {
      updatedValues[item?._id] = item?.title
    }
    if (Object.keys(updatedValues).length > 0) setError(null);
    formik.setFieldValue('specialisedId', updatedValues)
  }

  const handleFileUpload = async (e) => {
    setIsInValidFile(false);
    const file = e.target.files[0];
    const extension = file.name.split('.').pop();

    if (e.target.name === 'avatar' && !['png', 'jpg', 'jpeg'].includes(extension.toLowerCase())) {
      setIsInValidFile(true);
      return;
    }

    try {
      setIsUploading((prev) => ({
        ...prev,
        [e.target.name]: true
      }));
      const response = await utilService.getBucketUrl({
        location: 'users/',
        extension
      })
      const webUrlData = response.data.data[0];
      const { filename, preview, url } = webUrlData || {};

      const requestOptions = {
        method: 'PUT',
        headers: {
          "Content-Type": file.type
        },
        body: file,
        redirect: 'follow'
      };

      await utilService.uploadFile({
        url,
        requestOptions
      });

      setPreviews((prev) => ({
        ...prev,
        [e.target.name]: preview
      }));
      
      formik.setFieldValue(e.target.name, filename);
      setFileNames((prev) => ({
        ...prev,
        [e.target.name]: file.name
      }));
    }
    catch (err) {
      console.log(err);
    } finally {
      setIsUploading((prev) => ({
        ...prev,
        [e.target.name]: false
      }));
    }
  }

  const handleDiscard = (fieldName) => {
    formik.setFieldValue(fieldName, "");
    setPreviews((prev) => {
      const newPreviews = { ...prev };
      delete newPreviews[fieldName];
      return newPreviews;
    });
    setFileNames((prev) => {
      const newNames = { ...prev };
      delete newNames[fieldName];
      return newNames;
    });
  }

  const formatSpecializations = (data) => {
    let result = "Select Specialized";
    if (Object.values(formik.values.specialisedId)?.length > 0) {
      const namesArr = Object.values(formik.values.specialisedId);
      result = namesArr.slice(0, 4).join();
      if (namesArr.length > 4) {
        result += ` <b>+${namesArr.length - 4}</b>`
      }
    }
    return parse(result);
  }

  return (
    <div className="container-fluid login-page p-0">
      <div className="row relative">
        <div className="col-lg-7 pr-0">
          <div className="right-login-side">
            <div className="nav-bar-container">
              <Link to="/" className="nav-bar">
                <img alt="" src={Images.arrowleft} className="me-2 py-1" />
                Home
              </Link>
            </div>

            <div className="outer-div-form">
              <div className="form-div profile-form mb-5">
                <div className="tab-content-bg">
                  <div className="auth-tab-content authcontainer px-lg-5 px-3">
                    <div>
                      <p className="step-p">Step 1 of 3</p>
                      <div className="d-flex justify-content-between gap-2">
                        <div className="step-lines active"></div>
                        <div className="step-lines"></div>
                        <div className="step-lines"></div>
                      </div>
                    </div>
                    <h4 className="text-capitalize text-center form-hreading fw-bold text-white">
                      Build your Profile
                    </h4>
                    <form>
                      <div className="avatar-upload">
                        {isUploading?.avatar ? <></> : (
                          <div className="avatar-edit">
                            <input
                              type="file"
                              id="imageUpload"
                              name="avatar"
                              onChange={handleFileUpload}
                              onBlur={formik.handleBlur}
                              accept=".png, .jpg, .jpeg"
                            />
                            <label htmlFor="imageUpload" />
                          </div>)}
                        <div className="avatar-preview">
                          <div id="imagePreview" className="border border-secondary d-flex align-items-center justify-content-center position-relative">
                            {isUploading?.avatar ?
                              <LoaderIndicator />
                              : <img alt='' src={previews.avatar || myprofile} />
                            }
                            {previews.avatar && (
                              <button
                                type="button"
                                className="discard-btn avatar-discard"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleDiscard('avatar');
                                }}
                              >
                                <svg viewBox="0 0 24 24">
                                  <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      {isInValidFile ? <div className="text-danger text-center">Please upload correct image format!</div> : ''}

                      <div className="mb-30 text-left">
                        <label className="py-2">UAS Manufacturer</label>
                        <div className="form-control-bg">
                          <input
                            type="text"
                            placeholder="Enter UAS Manufacturer"
                            className="form-control rounded-3 bg-cyan w-100"
                            name="uasManufacturer"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                        {formik.touched.uasManufacturer && formik.errors.uasManufacturer ? (
                          <span className="text-danger">{formik.errors.uasManufacturer}</span>
                        ) : null}
                      </div>

                      <div className="mb-30 text-left">
                        <label className="py-2">UAS Model</label>
                        <div className="form-control-bg">
                          <input
                            type="text"
                            placeholder="Enter UAS Model"
                            className="form-control rounded-3 bg-cyan w-100"
                            name="uasModel"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                        {formik.touched.uasModel && formik.errors.uasModel ? (
                          <span className="text-danger">{formik.errors.uasModel}</span>
                        ) : null}
                      </div>

                      <div className="mb-30 text-left">
                        <label className="py-2">FAA Remote Pilot License # </label>
                        <div className="form-control-bg">
                          <input
                            type="text"
                            placeholder="Enter FAA Remote Pilot License #"
                            className="form-control rounded-3 bg-cyan w-100"
                            name="faaRegistrationNumber"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                        {formik.touched.faaRegistrationNumber && formik.errors.faaRegistrationNumber ? (
                          <span className="text-danger">{formik.errors.faaRegistrationNumber}</span>
                        ) : null}

                        <div className="upload-card mt-3">
                          <label className="uploadFile">
                            {isUploading?.faaRegistration ? (
                              <LoaderIndicator />
                            ) : previews?.faaRegistration ? (
                              <div className="preview-container w-100 h-100 position-relative">
                                <img alt='' src={previews.faaRegistration} className="preview-img" />
                                <button
                                  type="button"
                                  className="discard-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDiscard('faaRegistration');
                                  }}
                                >
                                  <svg viewBox="0 0 24 24">
                                    <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                </button>
                              </div>
                            ) : (
                              <>
                                <img alt='' src={uplodimg} />
                                <p>{'Upload FAA Drone Registration'}</p>
                              </>
                            )}
                            
                            {previews?.faaRegistration && !isUploading?.faaRegistration && (
                               <p className="mt-2 text-white-50 small text-truncate" style={{maxWidth: '100%'}}>{fileNames?.faaRegistration}</p>
                            )}

                            <input
                              type="file"
                              className="inputfile form-control"
                              name="faaRegistration"
                              onClick={(e) => (e.target.value = null)}
                              onChange={handleFileUpload}
                              onBlur={formik.handleBlur}
                              accept=".png, .jpg, .jpeg"
                            />
                          </label>
                        </div>
                        {formik.touched.faaRegistration && formik.errors.faaRegistration ? (
                          <span className="text-danger">{formik.errors.faaRegistration}</span>
                        ) : null}
                      </div>

                      <div className="mb-30 text-left">
                        <label className="py-2">Proof Of Insurance</label>
                        <div className="upload-card ">
                          <label className="uploadFile">
                            {isUploading?.insuranceProof ? (
                              <LoaderIndicator />
                            ) : previews?.insuranceProof ? (
                              <div className="preview-container w-100 h-100 position-relative">
                                <img alt='' src={previews.insuranceProof} className="preview-img" />
                                <button
                                  type="button"
                                  className="discard-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDiscard('insuranceProof');
                                  }}
                                >
                                  <svg viewBox="0 0 24 24">
                                    <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                </button>
                              </div>
                            ) : (
                              <>
                                <img alt='' src={uplodimg} />
                                <p>{'Upload Proof Of Insurance'}</p>
                              </>
                            )}
                            
                            {previews?.insuranceProof && !isUploading?.insuranceProof && (
                               <p className="mt-2 text-white-50 small text-truncate" style={{maxWidth: '100%'}}>{fileNames?.insuranceProof}</p>
                            )}

                            <input
                              type="file"
                              className="inputfile form-control"
                              name="insuranceProof"
                              onClick={(e) => (e.target.value = null)}
                              onChange={handleFileUpload}
                              onBlur={formik.handleBlur}
                              accept=".png, .jpg, .jpeg"
                            />
                          </label>
                        </div>
                        {formik.touched.insuranceProof && formik.errors.insuranceProof ? (
                          <span className="text-danger">{formik.errors.insuranceProof}</span>
                        ) : null}
                      </div>

                      <div className="mb-30 text-left">
                        <label className="py-2">Pilot License</label>
                        <div className="upload-card ">
                          <label className="uploadFile">
                            {isUploading?.pilotLicense ? (
                              <LoaderIndicator />
                            ) : previews?.pilotLicense ? (
                              <div className="preview-container w-100 h-100 position-relative">
                                <img alt='' src={previews.pilotLicense} className="preview-img" />
                                <button
                                  type="button"
                                  className="discard-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDiscard('pilotLicense');
                                  }}
                                >
                                  <svg viewBox="0 0 24 24">
                                    <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                </button>
                              </div>
                            ) : (
                              <>
                                <img alt='' src={uplodimg} />
                                <p>{'Upload Pilot License'}</p>
                              </>
                            )}
                            
                            {previews?.pilotLicense && !isUploading?.pilotLicense && (
                               <p className="mt-2 text-white-50 small text-truncate" style={{maxWidth: '100%'}}>{fileNames?.pilotLicense}</p>
                            )}

                            <input
                              type="file"
                              className="inputfile form-control"
                              name="pilotLicense"
                              onClick={(e) => (e.target.value = null)}
                              onChange={handleFileUpload}
                              onBlur={formik.handleBlur}
                              accept=".png, .jpg, .jpeg"
                            />
                          </label>
                        </div>
                        {formik.touched.pilotLicense && formik.errors.pilotLicense ? (
                          <span className="text-danger">{formik.errors.pilotLicense}</span>
                        ) : null}
                      </div>

                      <div className="mb-30 text-left">
                        <label className="py-2">Driver’s License</label>
                        <div className="upload-card ">
                          <label className="uploadFile">
                            {isUploading?.drivingLicense ? (
                              <LoaderIndicator />
                            ) : previews?.drivingLicense ? (
                              <div className="preview-container w-100 h-100 position-relative">
                                <img alt='' src={previews.drivingLicense} className="preview-img" />
                                <button
                                  type="button"
                                  className="discard-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleDiscard('drivingLicense');
                                  }}
                                >
                                  <svg viewBox="0 0 24 24">
                                    <path d="M18 6L6 18M6 6l12 12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                                  </svg>
                                </button>
                              </div>
                            ) : (
                              <>
                                <img alt='' src={uplodimg} />
                                <p>{'Upload Driver’s License'}</p>
                              </>
                            )}
                            
                            {previews?.drivingLicense && !isUploading?.drivingLicense && (
                               <p className="mt-2 text-white-50 small text-truncate" style={{maxWidth: '100%'}}>{fileNames?.drivingLicense}</p>
                            )}

                            <input
                              type="file"
                              className="inputfile form-control"
                              name="drivingLicense"
                              onClick={(e) => (e.target.value = null)}
                              onChange={handleFileUpload}
                              onBlur={formik.handleBlur}
                              accept=".png, .jpg, .jpeg"
                            />
                          </label>
                        </div>
                        {formik.touched.drivingLicense && formik.errors.drivingLicense ? (
                          <span className="text-danger">{formik.errors.drivingLicense}</span>
                        ) : null}
                      </div>

                      <div className="text-left">
                        <label className="py-2">Specialization</label>
                        <div className="position-relative">
                          <Button
                            className="btn m-0 btn-secondary text-left w-100  text-capitalize select-cat"
                            onClick={() => setModalShow(true)}
                          >
                            {formatSpecializations(formik.values.specialisedId)}
                          </Button>
                          <img
                            alt='' src={arrowdrop}
                            className="position-absolute arrow-right"
                          />

                          <ChooseCatpopup
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            handleSpeclialisedList={handleSpeclialisedList}
                            speclialisedIDs={Object.keys(formik.values.specialisedId)}
                          />
                          {error && <span className="text-danger">{error}</span>}
                        </div>
                      </div>

                      <div className="text-center ">
                        <button type="button" className="btn btn-primary text-capitalize" onClick={() => {
                          formik.handleSubmit();
                          if (Object.keys(formik.values.specialisedId).length === 0) {
                            setError('Please select category')
                          }
                        }}>
                          Next
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              <div className="d-flex mt-md-0 mt-2 flex-md-row flex-column bottom-ft justify-content-between auth-bottom-links">
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-start justify-content-center">
                  <Link to={`${LIVE_SITE_URL}terms-conditions`}>Terms of Services</Link>
                  <Link to={`${LIVE_SITE_URL}privacy-policy`}>Privacy Policy</Link>
                </div>
                <div className="mb-lg-0 mb-3 d-flex justify-content-md-end justify-content-center">
                  <p>© 2023 SkyyTask. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5 pl-0 pr-0 pt-0">
          <div className="left-bg-form">
            <div className="logo-container w-100">
              <Link to="/" className="mx-auto mt-4 d-flex justify-content-center">
                <img alt='' src={logowhite} className="logo" />
              </Link>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Step1;
